import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import PndApi from '../../../../../utils/pnd/PndRestApi';
import UserListTableView from './components/UserListTableView';
import LinearProgress from '@mui/material/LinearProgress';
import ModalAccountCreationForm from '../components/AccountCreationModal';
import ModalPasswordReset from '../components/PasswordRest/ModalPasswordReset';
import { ACCOUNT_LOIGN_RETRY_COUNT, ERROR_MESSAGES, ITC_ADMIN_ROLE_ID } from '../../../../../utils/pnd/PndConstants';
import { showNotification, successNofication } from 'src/shared/components/Notification';
import { SnackbarContent } from '@mui/material';
import PndRestApi from '../../../../../utils/pnd/PndRestApi';
import ConfirmationDialog from 'src/shared/components/ConfirmationDialog';
import { Box } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import PageHeader from 'src/shared/components/layout/PageHeader';

const UserIndex = () => {
  useEffect(() => {
    getAllCustomerByCustomerId();
  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [showUnlockConfirmation, setShowUnlockConfirmation] = useState(false);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isPasswordDiv, setPasswordDiv] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [isUnlockUserId, setUnlockUserId] = useState(null);
  const [isRedirect, setRedirect] = useState(false);

  const getAllCustomerByCustomerId = async () => {
    try {
      setLoading(true);
      const response = await PndApi.GetClientUsers();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableRowsData: response.data.data });
      } else if (response.status === 200 && response.data.status === 204) {
        setNoRecordFound(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error in getAllUsersById fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  if (isRedirect) {
    window.location.reload();
  }

  const showDialogBox = async (event) => {
    if (event) {
      setShowUnlockConfirmation(true);
      setUnlockUserId(event?.userId);
    }
  }

  const edit = async (event) => {
    if (event?.userId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - User Details")
    }
  }

  const add = () => {
    setTempData(null);
    setViewDetailPopup(true);
    if (localStorage.getItem('uri') == ITC_ADMIN_ROLE_ID)
      setTitle("Create Client Admin Account");
    else
      setTitle("Create Hub User Account");
  };

  const unlockUser = async () => {
    try {
      const response = await PndRestApi.UnlockedHubUserAccount(isUnlockUserId);
      if (response.status === 200 && response.data.status === 200) {
        successNofication(
          "theme-light",
          "ltr",
          `Message: User's account unlocked successfully.`
        );
        setRedirect(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
        return;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    }
  };

  const closeDialog = () => {
    setShowUnlockConfirmation(false);
  };

  const resetPassword = (event) => {
    if (event) {
      setTempData(event);
      setPasswordDiv(true);
      if (localStorage.getItem("uri") == ITC_ADMIN_ROLE_ID)
        setTitle("Client Admin Password Reset")
      else
        setTitle("Hub User Password Reset")
    }
  }

  const isItcAdmin = localStorage.getItem('uri') == ITC_ADMIN_ROLE_ID;

  return (
    <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <Container fluid style={{ maxWidth: '1400px' }}>
        <PageHeader
          icon={<GroupIcon fontSize="large" />}
          title={isItcAdmin ? "Client Admin Account Details" : "Hub Users Account Details"}
          subtitle="View and manage administrative and hub operations user accounts."
          gradient="linear-gradient(135deg, #0284c7 0%, #0369a1 100%)"
        />

        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

        <Box sx={{ position: 'relative' }}>
          {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && !isNoRecordFound && (
            <UserListTableView
              reactTableData={reactTableData}
              onAdd={add}
              onEdit={edit}
              onResetPassword={resetPassword}
              onUnlock={showDialogBox}
              isNoRecordFound={isNoRecordFound}
            />
          )}
          {isNoRecordFound && (
            <UserListTableView
              isNoRecordFound={isNoRecordFound}
              onAdd={add}
              onEdit={edit}
              onResetPassword={resetPassword}
              onUnlock={showDialogBox}
            />
          )}
          {/* {isNoRecordFound && <SnackbarContent message={'No Record Found'} />} */}
        </Box>

        {viewDetailPopup &&
          <ModalAccountCreationForm
            modalShow={viewDetailPopup}
            setModalShow={setViewDetailPopup}
            userData={temp}
            isTitle={isTitle}
          />}

        {isPasswordDiv && (
          <ModalPasswordReset
            modalShow={isPasswordDiv}
            setModalShow={setPasswordDiv}
            userData={temp}
            isTitle={isTitle}
          />
        )}

        {showUnlockConfirmation && (
          <ConfirmationDialog
            open={showUnlockConfirmation}
            onClose={closeDialog}
            onConfirm={() => unlockUser()}
            title="Confirmation"
            message="Are you sure, Do you want to proceed?"
          />
        )}
      </Container>
    </Box>
  );
};

export default UserIndex;